// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5b11f7e8","839":"3d1190c7"}[chunkId] + ".chunk.js";
};